import { getApiBaseUrl } from "../utils/ssoProvider";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../services/axiosInstance";

const API_URL = getApiBaseUrl();

// Async thunk to fetch labels
export const fetchLabels = createAsyncThunk("labels/fetchLabels", async (_, { rejectWithValue }) => {
  try {
    const res = await axiosInstance.get(`${API_URL}/v1/store/labels`);
    return res.data || [];
  } catch (error) {
    return rejectWithValue(error.response?.data?.detail || "Failed to fetch labels");
  }
});

// Async thunk to delete label
export const deleteLabel = createAsyncThunk("labels/deleteLabel", async (labelId, { rejectWithValue }) => {
  try {
    await axiosInstance.delete(`${API_URL}/v1/store/labels/${labelId}`);
    return labelId;
  } catch (error) {
    return rejectWithValue(error.response?.data?.detail || "Failed to delete label");
  }
});

const labelsSlice = createSlice({
  name: "labels",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearLabelsError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      // Fetch labels
      .addCase(fetchLabels.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete label
      .addCase(deleteLabel.pending, state => {
        state.loading = true;
      })
      .addCase(deleteLabel.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items.filter(label => label.id !== action.payload);
      })
      .addCase(deleteLabel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLabelsError } = labelsSlice.actions;
export default labelsSlice.reducer;
